import { promosFailure, promosRequest, promosSuccess } from './actions';
import { PROMOS_REQUEST_ERROR } from '../../constants/notifications';
import { resolveSearchPromosPage } from '../../services/promosSearch';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { TThunkAction } from '../../types/redux/thunk';
import { trackNewPageAction } from '../analytics';
import { setError } from '../error';

interface IParameters {
  path?: string;
  jsonQuery?: IJsonQuery;
}

export const promosRequestByParamsAction =
  (parameters: IParameters): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { logger, httpApi, custom } = context;

    const subdomain = custom.subdomain;

    try {
      dispatch(promosRequest());

      const data = await resolveSearchPromosPage({
        httpApi,
        logger,
        subdomain,
        path: parameters?.path,
        jsonQuery: parameters?.jsonQuery,
      });

      dispatch(promosSuccess(data));
      dispatch(trackNewPageAction());
    } catch (e) {
      dispatch(promosFailure());

      dispatch(setError({ id: Date.now(), message: PROMOS_REQUEST_ERROR }));
    }
  };
